__turbopack_context__.v({
  "className": "nunito_sans_f7b934d3-module__vV8Jla__className",
  "variable": "nunito_sans_f7b934d3-module__vV8Jla__variable",
});
